export default "__VITE_ASSET__BE4G2aKK__"